import moment from 'moment';
import { formatDate } from '../../helper/formatDate';

// Stored Oireachtas dates are calendar days at midnight UTC (a date input's
// "2026-09-27" becomes 2026-09-27T00:00Z on the server). Read them back by
// their UTC calendar day: parsing in local time turned 27 Sep 00:00Z into
// 26 Sep in the Americas, and every Save of the Event Details tab then wrote
// every date back one day earlier (ECRO 2026 drifted this way in production).
export const toDateInput = (v) => (v ? moment(formatDate(v)).format('YYYY-MM-DD') : '');
